/** */
export const createInitials = name => {
  const nameParts = name.split(" ");
  let initials = "";

  // Max out at 3 characters
  const numInitials = Math.min(nameParts.length, 3);
  for (let i = 0; i < numInitials; i++) {
    initials += nameParts[i].charAt(0);
  }
  return initials;
};

/** */
export const isNullOrWhiteSpace = value => {
  return value === null || value === undefined || typeof value !== "object" && (!value || value.toString().trim().length === 0);
};

/** */
export const formatPhoneNumber = phoneNumber => {
  if (phoneNumber) {
    return `${phoneNumber.slice(0, 3)}-${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6)}`;
  }
};

/** */
export const getUsersName = user => {
  if (user && user.firstName && user.lastName) {
    return `${user.firstName} ${user.lastName}`;
  }
  return user && user.firstName || "";
};

/** */
export const hasSpecialCharacters = value => {
  return /[^\w\s]/gi.test(value);
};

/** */
export const isValidEmail = value => {
  // RFC 5322 Standard
  const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return emailRegex.test(value);
};

/** */
export const formatNumber = value => value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

/** */
export const capitalizeFirstLetter = value => value.charAt(0).toUpperCase() + value.slice(1);

/** */
export const getStringError = error => {
  if (error instanceof Error) {
    if (error.message) return error.message;
    return "Unknown Error";
  }
  return String(error);
};

/** */
export const removeTrailingSlash = str => {
  return str.replace(/\/+$/, "");
};